module.exports = "/templates/templateaccessrole.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/templateaccessrole.html
// module id = 474
// module chunks = 0